import { Typography, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, IconButton, Tooltip } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { currencyFormat, dateFormat } from "../../app/util/util";
import useCashRegisters from "../../app/hooks/useCashRegisters";
import AppPagination from "../../app/components/AppPagination";
import { useAppDispatch } from "../../app/store/configureStore";
import { removeCashRegister, setPageNumber, getAxiosParamsForExport } from "../cash-registers/cashRegisterSlice";
import { useState } from "react";
import CashRegisterForm from "./CashRegisterForm";
//import { Product } from "../../app/models/product";
import agent from "../../app/api/agent";
import { LoadingButton } from "@mui/lab";
import { CashRegister } from "../../app/models/cashRegister";
import { exportToExcel } from "../../app/util/exportFile";
import { cashRegisterExportFields } from "../../app/util/exportSettings";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import CashRegisterFilterDrawer from "./CashRegisterFilterDrawer";
import { hasAdminOrWriteRole } from "../auth/authSlice";
export default function CashRegisters() {
    const { cashRegisters, metaData, cashRegisterParams } = useCashRegisters();
    const dispatch = useAppDispatch();
    const [editMode, setEditMode] = useState(false);
    const [selectedCashRegister, setSelectedCashRegister] = useState<CashRegister | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [target, setTarget] = useState("");

    function handleSelectCashRegister(cashRegister: CashRegister) {
        setSelectedCashRegister(cashRegister);
        setEditMode(true);
    }

    function handleDeleteCashRegister(id: string) {
        setLoading(true);
        setTarget(id);
        agent.CashRegister.delete(id)
            .then(() => dispatch(removeCashRegister(id)))
            .catch(error => console.log(error))
            .finally(() => setLoading(false));
    }

    function cancelEdit() {
        if (selectedCashRegister) setSelectedCashRegister(undefined);
        setEditMode(false);
    }

    function noWrapAndMinWidth() {
        return { whiteSpace: 'nowrap', maxWidth: 5 };
    }

    function noWrap() {
        return { whiteSpace: 'nowrap' };
    }

    function exportData() {
        let cashRegistersForExport: any;
        agent.CashRegister.getFilteredForExport('', getAxiosParamsForExport(cashRegisterParams))
            .then(data => {
                cashRegistersForExport = data.items;
            })
            .catch(error => console.log(error))
            .finally(() => {
                exportToExcel(`CashRegister`, cashRegisterExportFields, cashRegistersForExport);
            });
    }


    if (editMode) return <CashRegisterForm cashRegister={selectedCashRegister} cancelEdit={cancelEdit} />

    return (
        <>
            <Box display='flex' justifyContent='space-between'>
                <Typography variant='h5' sx={{ letterSpacing: '1px' }}>Cash Registers ({metaData?.totalCount || 0})</Typography>              
                <Box sx={{  alignItems: 'right' }}>
                    <CashRegisterFilterDrawer />
                    <Tooltip title="Export to Excel" placement="top">
                        <IconButton
                            size='large'
                            color='inherit'
                            onClick={exportData}
                            sx={{ ml: 'auto' }}
                        ><CloudDownloadIcon /></IconButton>
                    </Tooltip>
                    {hasAdminOrWriteRole() && <Tooltip title="Create Record" placement="top">
                        <IconButton
                            color='inherit'
                            size='large'
                            onClick={() => setEditMode(true)}
                            sx={{ ml: 'auto' }}
                        ><AddCircleIcon /></IconButton>
                    </Tooltip>}                 
                </Box>                             
            </Box>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={noWrap} >
                        <TableRow>
                            {hasAdminOrWriteRole() && <TableCell align="center">Actions</TableCell>}
                            <TableCell align="center" style={{ display: 'none' }}>Id</TableCell>
                            <TableCell align="center" style={{ display: 'none' }}>GasStationId</TableCell>
                            <TableCell align="center">CashRegisterDate</TableCell>
                            <TableCell align="center">StartingBalance</TableCell>
                            <TableCell align="center">EndingBalance</TableCell>
                            <TableCell align="center">Overage</TableCell>
                            <TableCell align="center">Shortage</TableCell>
                            <TableCell align="center">CashOnHand</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={noWrap}  >
                        {cashRegisters.map((cashRegister) => (
                            cashRegister.id &&
                            <TableRow
                                key={cashRegister.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }}}
                            >
                                {hasAdminOrWriteRole() && <TableCell sx={noWrapAndMinWidth} align="center">
                                    <Button style={{ padding: 0 }} onClick={() => handleSelectCashRegister(cashRegister)} startIcon={<Edit />} />
                                    <LoadingButton
                                        style={{ padding: 0 }}
                                        loading={loading && target === cashRegister.id}
                                        startIcon={<Delete />}
                                        color='error'
                                        onClick={() => handleDeleteCashRegister(cashRegister.id || '')}
                                    />
                                </TableCell>}
                                <TableCell component="th" scope="row" style={{ display: 'none' }}>
                                    {cashRegister.id}
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ display: 'none' }}>
                                    {cashRegister.gasStationId}
                                </TableCell>
                                <TableCell sx={noWrap} align="center">{dateFormat(cashRegister.cashRegisterDate?.toString() || '')}</TableCell>
                                <TableCell align="center">{currencyFormat(cashRegister.startingBalance || 0)}</TableCell>
                                <TableCell align="center">{currencyFormat(cashRegister.endingBalance || 0)}</TableCell>
                                <TableCell align="center">{currencyFormat(cashRegister.overage || 0)}</TableCell>
                                <TableCell align="center">{currencyFormat(cashRegister.shortage || 0)}</TableCell>
                                <TableCell align="center">{currencyFormat(cashRegister.cashOnHand || 0)}</TableCell>
                                
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
                {metaData &&
                <Box sx={{ pt: 2 }}>
                    <AppPagination
                        metaData={metaData}
                        onPageChange={(page: number) => dispatch(setPageNumber({ pageNumber: page }))}
                    />
                </Box>
            }
        </>
    )
}